import { render, staticRenderFns } from "./VMissingData.vue?vue&type=template&id=7f2d543a&"
import script from "./VMissingData.vue?vue&type=script&lang=js&"
export * from "./VMissingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports